import { Placeholder } from "react-bootstrap";


export const PlaceholderButton = ({ ...props }) => {
    return (
        <Placeholder.Button xs={12} aria-hidden="true" {...props} />
    );
};

export const PlaceholderTextEditor = ({ ...props }) => {
    return (
        <Placeholder as="p" animation="glow" >
            <Placeholder xs={12} size="lg" bg="light" {...props} />
            <Placeholder xs={12} size="sm" bg="light" {...props} />
            <Placeholder xs={12} size="xs" bg="light" {...props} />
        </Placeholder>
    );
};